export default {"src":"/_next/static/media/left_arrow_icon.f91799a7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};